<template>
  <div class="pay">
    <div class="title-div">
      <van-icon name="arrow-left" />
      <span>支付页面</span>
      <div class="right-title"></div>
    </div>
    <van-cell-group style="width: 100%">
      <van-cell title="门店名称" :value="detail.storeName" />
      <van-cell title="产品名称" :value="detail.productNames" />
      <van-cell
        title="付款类型"
        :value="detail.installment == 1 ? '分期' : '全款'"
      />
      <van-cell
        title="分期通道"
        v-if="detail.installment == 1"
        :value="getInstallmentChannel"
      />
      <van-cell title="订单金额" :value="detail.receiveAmount" />
      <van-cell
        title="首付款"
        v-if="detail.installment == 1 && detail.installmentChannel == 3"
        :value="detail.firstPayment"
      />
      <van-cell title="订单编号" :value="insuranceNo" />
      <!-- <van-cell title="备注" value="内容">
        <template #default>
          <van-field v-model="remark" label="备注" />
        </template>
      </van-cell> -->
      <!-- <van-field v-model="remark" label="备注" /> -->
    </van-cell-group>
    <!-- <p class="paymoney margin-top-40">支付金额：{{ parms.amount }} 元</p> -->
    <div class="col justify-between btns content">
      <van-radio-group
        v-model="payWay"
        class="radio-group"
        v-if="payWayList.length"
      >
        <van-cell-group inset>
          <van-cell
            title="微信支付"
            clickable
            @click="payWay = 'wxH5'"
            v-if="payWayList.includes('wxH5')"
          >
            <template #icon>
              <div class="pay-method">
                <van-image
                  width="30"
                  height="30"
                  :src="require('@/assets/pay/wx.png')"
                />
              </div>
            </template>
            <template #right-icon>
              <van-radio name="wxH5" />
            </template>
          </van-cell>
          <van-cell
            title="支付宝支付"
            clickable
            @click="payWay = 'alipayH5'"
            v-if="payWayList.includes('alipayH5')"
          >
            <template #icon>
              <div class="pay-method">
                <van-image
                  width="30"
                  height="30"
                  :src="require('@/assets/pay/alipay.png')"
                />
              </div>
            </template>
            <template #right-icon>
              <van-radio name="alipayH5" />
            </template>
          </van-cell>
          <van-cell
            title="支付宝花呗（分期）"
            clickable
            @click="payWay = 'alipayHuabei'"
            v-if="payWayList.includes('alipayHuabei')"
          >
            <template #icon>
              <div class="pay-method">
                <van-image
                  width="30"
                  height="30"
                  :src="require('@/assets/pay/huabei.png')"
                />
              </div>
            </template>
            <template #right-icon>
              <van-radio name="alipayHuabei" />
            </template>
          </van-cell>
          <van-cell
            title="银联支付（分期）"
            clickable
            @click="payWay = 'unionPayInst'"
            v-if="payWayList.includes('unionPayInst')"
          >
            <template #icon>
              <div class="pay-method">
                <van-image
                  width="30"
                  height="30"
                  :src="require('@/assets/pay/yinlian.png')"
                />
              </div>
            </template>
            <template #right-icon>
              <van-radio name="unionPayInst" />
            </template>
          </van-cell>
          <van-cell
            title="衍生分期（分期）"
            clickable
            @click="payWay = 'agentCollect'"
            v-if="payWayList.includes('agentCollect')"
          >
            <template #icon>
              <div class="pay-method">
                <van-image
                  width="30"
                  height="30"
                  :src="require('@/assets/logo.png')"
                />
              </div>
            </template>
            <template #right-icon>
              <van-radio name="agentCollect" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div class="installmentNum" v-if="detail?.installmentChannel == 2">
        <template v-if="parms?.status == 'NOTPAY'">
          已下单无法切换分期数，点击继续完成支付
        </template>
        <template v-else>
          <div class="installment-title">选择分期数：</div>
          <div class="installment-list">
            <div
              class="installment-item"
              :class="{
                'installment-active': item.num == installmentNum,
                'installment-readonly':
                  item.num == installmentNum && parms?.status == 'NOTPAY',
              }"
              v-for="item in installmentList"
              :key="item.num"
              @click="setInstallmentNum(item.num)"
            >
              <div class="left">
                <div class="installment-radio"></div>
                <div>
                  <div class="installment-type">{{ item.type }}</div>
                  <div class="installment-desc">{{ item.desc }}</div>
                </div>
                <!-- <van-radio-group v-model="installmentNum" shape="dot">
                    <van-radio :name="item.num">
                      <div class="installment-type">{{ item.type }}</div>
                      <div class="installment-desc">{{item.desc}}</div>
                    </van-radio>
                  </van-radio-group> -->
              </div>
              <div class="right">
                <div class="price">
                  {{ item.price }}
                </div>
                <div class="unit">/期</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="pay-box">
        <van-button
          block
          type="info"
          class=""
          style="letter-spacing: 2px; font-size: 16px; width: 100%"
          @click="onSubmit"
          >支&nbsp;付</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import storage from "@/utils/storage";
import {
  getMultPolicy,
  payPolicy,
  payOrder,
  payQuery,
  queryOrder,
} from "@/api/extendedWarranty";
import { receiveCodeDetail, installmentStep } from "@/api/sign";

import { queryContractInfo } from "@/api/sign";
export default {
  data() {
    return {
      parms: {},
      payWay: "",
      payWayList: [],
      insuranceNo: "",
      remark: "",
      curent: 3,
      obj: {},
      payWayObj: {
        wxH5: "微信",
        alipayH5: "支付宝",
        alipayHuabei: "花呗",
        unionPayInst: "银联",
        agentCollect: "衍生",
      },
      info: {},
      detail: {},
      stepInfo: {},
      installmentNum: 3,
      installmentList: [],
    };
  },
  async created() {
    this.insuranceNo = this.$route.query.insuranceNo;
    if (!this.insuranceNo) {
      this.$toast.fail("无保单号，请先生成保单");
      return;
    }
    await this.receiveCodeDetail();
    let res = await installmentStep({ orderNo: this.insuranceNo });
    // if (!res.success) {
    //   this.$toast.fail(res.respMag);
    //   return;
    // }
    this.stepInfo = res;
    if (this.detail.installment == 1 && this.detail.installmentChannel == 3) {
      // let res = await installmentStep({ orderNo: this.insuranceNo });
      // this.stepInfo = res;
      // 分期步骤：0-待付首付款；1-完成首付款；2-确认分期信息；3-签署分期协议；4-绑卡；9-完成
      if (
        this.stepInfo.installment == 1 &&
        this.stepInfo.installmentSteps > 1
      ) {
        if (this.stepInfo.installmentSteps == 9) {
          this.$toast.fail("该分期单已签署衍生分期协议");
          setTimeout(() => {
            this.$router.replace({
              path: "/sign/account",
              query: { insuranceNo: this.insuranceNo },
            });
          }, 2000);
          return;
        } else {
          this.$toast.fail("该分期单已付完首付款");
          setTimeout(() => {
            this.$router.replace({
              path: "/pay/sign",
              query: { insuranceNo: this.insuranceNo },
            });
          }, 2000);
          return;
        }
      }
    }
    this.getPayInfo2();
    // this.getMultPolicy();
  },
  computed: {
    canPay() {
      return ["NOTPAY", "FAIL", "UNKNOW"].includes(this.parms.status);
    },
    getInstallmentChannel() {
      {
        return ["", "银联分期", "支付宝花呗", "衍生分期"][
          this.detail.installmentChannel
        ];
      }
    },
  },
  methods: {
    setInstallmentNum(e) {
      if (this.parms.status == "NOTPAY") {
        return;
      }
      this.installmentNum = e;
    },
    async installmentStep() {
      let res = await installmentStep({ orderNo: this.insuranceNo });
      this.stepInfo = res;
      // 1-待完成付首付款；2-待确认分期信息；3-待签署分期协议；4-待绑定银行卡；9-分期签署已完成。
      if (
        this.stepInfo.installment == 1 &&
        this.stepInfo.installmentSteps > 1
      ) {
        this.$toast.fail("该分期单已付完首付款");
        setTimeout(() => {
          this.$router.replace({
            path: "/pay/sign",
            query: { insuranceNo: this.insuranceNo },
          });
        }, 2000);
        return;
      }
    },
    async getMultPolicy() {
      if (this.insuranceNo) {
        const res = await getMultPolicy({
          insuranceNo: this.insuranceNo,
          payWay: "wxQR",
        });
        if (!res.success) {
          this.$toast.fail(res.respMag);
          return;
        }
        this.info = res.content;
        this.curent = res.content.periods ? res.content.periods : 3;
        const info = await queryContractInfo({ insuranceNo: this.insuranceNo });
        if (info.success) {
          this.isPay = info.content.finishPayment;
          this.isSign = info.content.signContract;
          this.isAgreement = info.content.signAgreement;
          if (
            this.isPay &&
            this.isAgreement &&
            this.detail.installmentChannel != 3
          ) {
            storage.setItem("insuranceNo", this.insuranceNo);
            this.$toast.fail("订单已经完成");
            setTimeout(() => {
              this.$router.push({
                path: "/sign/account",
                query: { insuranceNo: this.insuranceNo },
              });
            }, 2000);
          }
        }
      }
    },
    async receiveCodeDetail() {
      if (this.insuranceNo) {
        const res = await receiveCodeDetail({ orderNo: this.insuranceNo });
        if (!res.success) {
          this.$toast.fail(res.msg || res.respMag);
          return;
        }
        this.installmentList = [
          {
            num: 3,
            price: "￥" + (res.content.receiveAmount / 3).toFixed(2),
            type: "3期",
            desc: "0利息",
          },
          {
            num: 6,
            price: "￥" + (res.content.receiveAmount / 6).toFixed(2),
            type: "6期",
            desc: "0利息",
          },
          // {
          //   num: 12,
          //   price: "￥" + (res.content.receiveAmount / 12).toFixed(2),
          //   type: "12期",
          //   desc: "0利息",
          // },
        ];
        this.detail = res.content;
      }
    },
    async getPayInfo2() {
      // 分期字段installment为null时为旧版本，做兼容
      if (this.detail.installment === null) {
        this.payWayList.push("unionPayInst");
        if (/MicroMessenger/.test(window.navigator.userAgent)) {
          // 微信客户端
          this.payWayList.push("wxH5");
        } else if (/AlipayClient/.test(window.navigator.userAgent)) {
          this.payWayList.push("alipayH5");
          this.payWayList.push("alipayHuabei");
        }
      } else {
        // 分期字段installment为0和1时为新版本，加了衍生分期
        if (
          this.detail.installment == 0 ||
          (this.detail.installment == 1 &&
            this.detail?.installmentChannel === 3)
        ) {
          if (/MicroMessenger/.test(window.navigator.userAgent)) {
            // 微信客户端
            this.payWayList.push("wxH5");
          } else if (/AlipayClient/.test(window.navigator.userAgent)) {
            this.payWayList.push("alipayH5");
          }
        } else {
          if (this.detail?.installmentChannel === 1) {
            this.payWayList.push("unionPayInst");
          } else if (this.detail?.installmentChannel === 2) {
            // 支付宝分期分期
            this.payWayList.push("alipayHuabei");
          }
        }
      }

      // if (this.detail?.installmentChannel === 3){
      //   this.payWayList.push("agentCollect");
      // }
      this.payWay = this.payWayList[0];
      if (!this.payWay) {
        this.$toast.fail("无可用的支付方式，请使用微信或支付宝扫码支付");
      }
      const res = await queryOrder({
        insuranceNo: this.insuranceNo,
        payWay: this.payWay,
      });
      if (!res.success) {
        this.$toast.fail(res.respMag);
        return;
      }
      this.parms = res.content;
      this.obj = res.content;
      // 为支付宝分期时选择完分期数后，自动提交支付
      if (
        res.content.status == "NOTPAY"
      ) {
        this.onSubmit('auto');
      }
      if (
        res.content.status == "SUCCESS" &&
        this.detail.installmentChannel != 3
      ) {
        this.$router.push({
          path: "/pay/succeed",
          query: { insuranceNo: this.insuranceNo },
        });
      }
    },
    async onSubmit(action) {
      if (!this.payWay) {
        this.$toast.fail("无可用的支付方式，请使用微信或支付宝扫码支付");
        return;
      }
      if (
        this.detail?.installmentChannel === 2 &&
        !/AlipayClient/.test(window.navigator.userAgent)
      ) {
        // 支付宝分期分期
        this.$toast.fail("请使用支付宝扫码支付");
        return;
      }
      const data = {
        ...this.parms,
        time: new Date().getTime()
      };
      if (this.detail?.installmentChannel === 2){
        data.periods = this.installmentNum;
      }
      data.payWay = this.payWay;
      data.insuranceNo = this.insuranceNo;
      data.amount = this.parms.amount
        ? Number(this.parms.amount)
        : this.parms.amount;
      data.productId = this.parms.productId
        ? Number(this.parms.productId)
        : this.parms.productId;
      data.userId = this.parms.userId
        ? Number(this.parms.userId)
        : this.parms.userId;
      delete data.status;
      if (action != 'auto'){
        let title = ''
        if (
          this.detail.installmentChannel == 2 &&
          this.parms.status == "UNKNOW"
        ){
          title = '进入支付之后后无法再切换分期数和变更信息，请确认是否继续？'
        } else {
          title = '进入支付之后无法再变更信息，请确认是否继续？'
        }
        this.$dialog
        .confirm({
          title: "提示",
          message: title,
        })
        .then(() => {
          payOrder(data).then((res) => {
            if (res.success === false) {
              this.$toast.fail(res.respMag);
            } else {
              res.content.codeUrl &&
                (window.location.href = res.content.codeUrl);
            }
          });
        });
      } else {
        payOrder(data).then((res) => {
          if (res.success === false) {
            this.$toast.fail(res.respMag);
          } else {
            res.content.codeUrl &&
              (window.location.href = res.content.codeUrl);
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.pay {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
  /* justify-content: center; */
  // padding: 20px 30px;
  min-height: 100vh;
  .title-div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    font-size: 16px;
    border-bottom: 1px solid #d7d7d7;
    background-color: #ffffff;
  }
  .red {
    color: red;
  }
  .col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-cell {
    height: 50px;
  }
  .van-cell__title {
    display: flex;
    align-items: center;
  }
  .installmentNum {
    width: 100%;
    font-size: 15px;
    padding: 16px;
    padding-bottom: 0;
    background-color: #ffffff;
    .installment-title {
      font-size: 15px;
      font-weight: bold;
    }
    .installment-list {
      .installment-item {
        display: flex;
        justify-content: space-between;
        margin: 16px 0;
        padding: 16px;
        border: 1px solid #d7d7d7;
        border-radius: 8px;
        .left {
          display: flex;
          align-items: center;
          .installment-radio {
            width: 20px;
            height: 20px;
            border: 1px solid #d7d7d7;
            border-radius: 50%;
            margin-right: 8px;
          }
          .installment-type {
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 2px;
          }
          .installment-desc {
            font-size: 12px;
            color: #999999;
          }
        }
        .right {
          .price {
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 2px;
          }
          .unit {
            font-size: 12px;
            color: #999999;
            text-align: right;
          }
        }
      }
      .installment-item:active {
        background-color: #f8f8f8;
      }
      .installment-active {
        border-color: #1890ff;
        background-color: rgba(24, 144, 255, 0.1);
        .left {
          .installment-radio {
            border: 5px solid #1890ff;
            border-radius: 50%;
          }
        }
      }
      .installment-readonly {
        border-color: #777777;
        background-color: rgba(119, 119, 119, 0.1);
        .left {
          .installment-radio {
            border: 5px solid #777777;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
.content {
  width: 100%;
  margin-top: 16px;
}
.pay-box {
  width: 100%;
  padding: 16px 16px 32px;
  background-color: #ffffff;
}
.paymoney {
  font-size: 22px;
  /* margin-top: 20px; */
}
.radio-group {
  margin-bottom: 16px;
  width: 100%;
}
.pay-method {
  margin-right: 16px;
}
.van-hairline--top-bottom::after {
  border: none;
}
</style>
